import * as React from "react";
const SvgCaretGsd = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 6,0 L 15,9 L 6,18", fill: "none", stroke: "currentColor", transform: "translate(-1)" }));
export default SvgCaretGsd;
